/**
 * Le drapeau qui relie les deux moitiés du step-up.
 *
 * Le Hosted UI classique n'honore pas `prompt=login` : tant que son cookie de
 * session existe, il redélivre un code sans redemander le mot de passe. Le
 * step-up commence donc par déconnecter du Hosted UI (page Security), et se
 * termine par la reconnexion avec le scope des passkeys (page « Signed out »).
 * Entre les deux la page est rechargée : le drapeau vit dans `sessionStorage`
 * (propre à l'onglet) et ne contient aucun secret.
 */
const KEY = "ps.cp.stepUp";

export function markStepUpPending(): void {
  try {
    window.sessionStorage.setItem(KEY, "1");
  } catch {
    // Stockage indisponible : la déconnexion aura lieu, sans reconnexion automatique.
  }
}

export function isStepUpPending(): boolean {
  try {
    return window.sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function clearStepUpPending(): void {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // Rien à effacer si le stockage est indisponible.
  }
}
